(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seo-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    
    document.querySelectorAll(".seo-content").forEach(seoText => {
      const textContainers = seoText.querySelectorAll("[data-hidden-content]");
      const readMoreButtons = seoText.querySelectorAll("[data-read-content]");

      if (!textContainers.length || !readMoreButtons.length) return;

      seoText.querySelectorAll("[data-hidden-content] a").forEach(a => a.setAttribute("tabindex", "-1"));

      function toggleContent(e) {
        const btn = e.currentTarget;
        const contentId = btn.dataset.readContent;
        if (!contentId) return;

        const seoTextContainer = seoText.querySelector(`[data-hidden-content="${contentId}"]`);
        if (!seoTextContainer) return;

        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const newState = !expanded;

        seoTextContainer.toggleAttribute('open', newState);
        seoTextContainer.querySelectorAll("a").forEach(a => a.setAttribute("tabindex", newState ? "0" : "-1"));
        
        readMoreButtons.forEach(btn => {
          const labelMore = btn.dataset.labelMore || 'Read more';
          const labelLess = btn.dataset.labelLess || 'Read less';
  
          btn.setAttribute('aria-expanded', String(newState));
          const btnLabel = btn.querySelector('span');
          if (btnLabel) btnLabel.textContent = newState ? labelLess : labelMore;
        });
      }

      readMoreButtons.forEach(btn => btn.addEventListener('click', toggleContent));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
